import apiFetch from '../apiFetch'

export default function (token, sourceChannelId) {
  return apiFetch({ endPoint: `SourceChannel/${sourceChannelId}/Complete`, method: 'GET', body: null, token: token })
}
